// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"282":"8ac04c43","453":"af205ec6","938":"0412bda5"}[chunkId] + ".chunk.js";
};